import qualityTypes from 'helpers/enums/interactiveVideo/qualityTypes'
import settingsMenuItemTypes from 'helpers/enums/settings_menu/settingsMenuItemTypes'

const qualitiesFormatter = (versionSizes, selectedVideoQuality) => {
	const videoQualities = Object.keys(versionSizes).map(versionSize => {
		const size = qualityTypes[versionSize]
		return {
			type: settingsMenuItemTypes.CHILD,
			payload: {
				id: versionSize,
				label: `${size}p`,
				isSelected: versionSize === selectedVideoQuality,
			},
		}
	})

	return videoQualities
}

export default qualitiesFormatter
